import React, { ReactNode } from 'react';
import classNames from 'classnames';
import Text from '../text/Text';
import { IconXClose } from '@pentabd/icons';

interface ApplicationStatusProps {
  title?: string;
  subtitle?: string;
  progressBar?: ReactNode;
  status1?: string;
  status2?: string;
  className?: string;
  type?:
    | 'primary'
    | 'danger'
    | 'success'
    | 'secondary'
    | 'warning'
    | 'info'
    | 'dark';
  crossButton?: boolean;
  crossButtonOnClick?: () => void;
  status1onClick?: () => void;
  status2onClick?: () => void;
}
const ApplicationStatus = ({
  title,
  subtitle,
  progressBar,
  status1,
  status2,
  className,
  type = 'primary',
  crossButton,
  crossButtonOnClick,
  status1onClick,
  status2onClick,
}: ApplicationStatusProps) => {
  return (
    <div
      className={classNames(
        'w-100 py-12 px-8 d-flex flex-column rounded-4',
        className,
      )}
    >
      <div className="d-flex justify-content-between">
        {title && (
          <Text size="sm" weight="semibold" color="dark">
            {title}
          </Text>
        )}
        {crossButton && (
          <div onClick={crossButtonOnClick} className="pointer">
            <IconXClose size="24" stroke="subtitle2" />
          </div>
        )}
      </div>
      {subtitle && (
        <Text size="sm" weight="normal" color="subtitle2">
          {subtitle}
        </Text>
      )}
      {progressBar && <div className="py-8">{progressBar}</div>}
      <div className="d-flex gap-6">
        {status1 && (
          <div onClick={status1onClick} className="pointer">
            <Text size="sm" weight="semibold" color="subtitle2">
              {status1}
            </Text>
          </div>
        )}
        {status2 && (
          <div onClick={status2onClick} className="pointer">
            <Text size="sm" weight="semibold" color={type}>
              {status2}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationStatus;
